// ============================================================
// หน้า ListCutOf — รายการตัดหนี้
// ------------------------------------------------------------
// แสดงบิลที่ถูก "ตัดหนี้" (เลิกตามเก็บ) ไปแล้ว และยกเลิกการตัดหนี้กลับได้
//
// มี 2 โหมด ใช้คนละ API ไม่เกี่ยวกัน
//   "old" ตัดทั้งยอด        — ตัดทั้งบิล ยกเลิกทีละ record_water_id
//   "new" เลือกตัดเฉพาะรายการ — ตัดเฉพาะบางช่องค่าใช้จ่าย ยกเลิกทีละ writeoff_item_id
//
// ยกเลิกตัดหนี้แล้วบิลกลับมาค้างชำระ จึงต้องคิดยอด/เบี้ยปรับของห้องนั้นใหม่ทุกครั้ง
// ============================================================

import React, { Component } from "react";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import { tokens, success, GET, PUT, total, getStorage, toFixed, format_date, DatePicker, loading, calculate_water, Paginate, ActionIcon, ICON } from "../../shared/index.js";

// ช่องค่าใช้จ่ายที่ต้องคิดยอด "ที่ถูกตัดหนี้" ใหม่จากรายการย่อย
//   k  = ฟิลด์บนบิล
//   sk = ฟิลด์ "เก็บเงินช่องนี้แล้ว" ในรายการย่อย
//   vk = ชื่อฟิลด์ยอดเงินในรายการย่อย ถ้าต่างจาก k
const WRITEOFF_FIELDS = [
  { k: "water_bill", sk: "s_water_bill" },
  { k: "waste_cost", sk: "s_waste_cost" },
  { k: "reduce_debt", sk: "s_reduce_debt" },
  { k: "other_income", sk: "s_other_income" },
  { k: "meter_connect_cost", sk: "s_meter_connect_cost" },
  { k: "late_payment", sk: "s_late_payment" },
  { k: "fire_cost", sk: "s_fire_cost" },
  { k: "equipment_maintenance_fee", sk: "s_equipment_maintenance_fee" },
  { k: "common_expenses", sk: "s_common_expenses" },
  { k: "cable_cost", sk: "s_cable_cost" },
  { k: "add_debt", sk: "s_add_debt" },
];

// คอลัมน์สำหรับโหมด "เลือกตัดเฉพาะรายการ" — ชื่อและลำดับเดียวกับโหมดตัดทั้งยอด
// ข้อมูลมาจาก Record_water_writeoff_item ซึ่ง backend คืนค่าตรงคอลัมน์อยู่แล้ว ไม่ต้องคำนวณเพิ่ม
const writeoffItemColumns = [
  { key: "water_bill", label: "ค่าน้ำประปา" },
  { key: "equipment_maintenance_fee", label: "ค่ารักษาอุปกรณ์น้ำ" },
  { key: "common_expenses", label: "ค่าส่วนกลาง" },
  { key: "waste_cost", label: "ค่าขยะ" },
  { key: "cable_cost", label: "ค่าเคเบิล" },
  { key: "other_income", label: "รายรับอื่นๆ" },
  { key: "debt_adjust", label: "เพิ่ม/ลดหนี้", compute: (item) => (item.add_debt || 0) - (item.reduce_debt || 0) },
  { key: "fire_cost", label: "ค่าเบี้ยประกัน" },
  { key: "meter_connect_cost", label: "ค่าต่อกลับมิเตอร์" },
  { key: "late_payment", label: "ค่าปรับชำระล่าช้า" },
];

// popup ยืนยันลบ (ใช้ร่วมกัน 2 โหมด)
const confirmDelete = (onConfirm) => {
  Swal.fire({
    icon: "warning",
    title: "ยืนยันการลบข้อมูล",
    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "ลบข้อมูล",
    cancelButtonText: "ยกเลิก",
  }).then((result) => result.isConfirmed && onConfirm());
};

export default class ListCutOf extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    page: 1,
    filter_data_search: "",
    start_date: null,
    end_date: null,
    list_mode: "old", // "old" = ตัดทั้งยอด | "new" = เลือกตัดเฉพาะรายการ
    // โหมดตัดทั้งยอด
    data: null,
    id: "",
    modal_update: false,
    // โหมดเลือกตัดเฉพาะรายการ
    data_item: null,
    id_item: "",
    modal_update_item: false,
  });

  async componentDidMount() {
    loading(false);
    await this.GetAll();
  }

  // เงื่อนไขการค้นหา (ใช้ร่วมกัน 2 โหมด)
  searchPayload = () => ({
    data_search: this.state.filter_data_search,
    start_date: this.state.start_date ? format_date(this.state.start_date, "yyyy-mm-dd", "en") : "",
    end_date: this.state.end_date ? format_date(this.state.end_date, "yyyy-mm-dd", "en") : "",
  });

  // ---------- โหมดตัดทั้งยอด ----------

  // คิดยอดที่ "ถูกตัดหนี้" ของแต่ละช่อง
  // ช่องไหนมีการเก็บเงินไปแล้วแม้แต่รายการเดียว = ไม่ถือว่าถูกตัดหนี้ ตั้งเป็น 0
  // ช่องที่ไม่มีการเก็บเงินเลย = รวมยอดของทุกรายการย่อย
  recalcWriteoff = (item) => {
    const payments = item.transaction_payments;
    WRITEOFF_FIELDS.forEach(({ k, sk, vk }) => {
      item[k] = payments.every((p) => !p[sk]) ? total(payments, vk || k) : 0;
    });

    item.total_amount =
      item.water_bill +
      item.waste_cost +
      item.other_income +
      item.meter_connect_cost +
      item.late_payment +
      item.fire_cost +
      item.equipment_maintenance_fee +
      item.common_expenses +
      item.cable_cost +
      item.add_debt -
      item.reduce_debt;
  };

  GetAll = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/record-water/water-clear-bill/page/${this.state.page}/${getStorage("project_id")}`, this.searchPayload());
    if (result?.status) {
      result.data.data.forEach((item) => {
        if (item.transaction_payments?.length > 0) this.recalcWriteoff(item);
      });
      this.setState({ data: result.data });
    }
    loading(false);
  };

  // ---------- โหมดเลือกตัดเฉพาะรายการ (คนละ endpoint กับด้านบน) ----------

  GetAllItem = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/record-water/water-clear-bill-item/page/${this.state.page}/${getStorage("project_id")}`, this.searchPayload());
    if (result?.status) this.setState({ data_item: result.data });
    loading(false);
  };

  // ---------- ค้นหา / สลับโหมด ----------

  // ฟังก์ชันโหลดข้อมูลของโหมดที่เปิดอยู่
  loader = (mode = this.state.list_mode) => (mode === "new" ? this.GetAllItem : this.GetAll);

  switchListMode = (mode) => {
    if (mode === this.state.list_mode) return;
    this.setState({ list_mode: mode, page: 1 }, this.loader(mode));
  };

  Search = () => this.setState({ page: 1 }, this.loader());

  Reset = () => this.setState({ filter_data_search: "", start_date: null, end_date: null, page: 1 }, this.loader());

  // ---------- ยกเลิกการตัดหนี้ ----------

  // ยกเลิกตัดหนี้แล้วต้องคิดยอดของห้องที่เกี่ยวข้องใหม่ (ทีละห้อง ไม่ซ้ำ)
  recalcAddresses = async (rows) => {
    for (const address of [...new Set(rows.map((e) => e.address_number))]) {
      await calculate_water(address);
    }
  };

  // โหมดตัดทั้งยอด — ยกเลิกทีละ record_water_id (ยิงพร้อมกันได้)
  cancelClearBill = async (ids) => {
    loading(true);
    const results = await Promise.all(ids.map((id) => PUT(tokens, `v1/TH/record-water/cancle-clear-bill/${getStorage("project_id")}`, { record_water_id: id })));

    if (!results.every((res) => res?.status)) {
      loading(false);
      return;
    }

    await this.recalcAddresses(this.state.data.data.filter((e) => ids.includes(e.record_water_id)));
    success();
    this.clear_form();
    this.GetAll();
  };

  // โหมดเลือกตัดเฉพาะรายการ — ส่งรายการที่จะยกเลิกไปทีเดียว
  cancelClearBillItem = async (writeoff_item_ids) => {
    loading(true);
    const result = await PUT(tokens, `v1/TH/record-water/cancle-clear-bill-item/${getStorage("project_id")}`, { writeoff_item_list: writeoff_item_ids });

    if (!result?.status) {
      loading(false);
      return;
    }

    await this.recalcAddresses(this.state.data_item.data.filter((e) => writeoff_item_ids.includes(e.writeoff_item_id)));
    success();
    this.setState({ filter_data_search: "", start_date: null, end_date: null, page: 1, modal_update_item: false, id_item: "" }, this.GetAllItem);
  };

  clear_form = () => this.setState(this.getInitialState(), this.GetAll);

  // ---------- ติ๊กเลือกแถว ----------

  // key = "data" (โหมดตัดทั้งยอด) หรือ "data_item" (โหมดเลือกตัดเฉพาะรายการ)
  toggleAll = (key) => (e) => {
    const group = { ...this.state[key] };
    group.data.forEach((item) => (item.selected = e.target.checked));
    this.setState({ [key]: group });
  };

  toggleRow = (key) => (index, checked) => {
    const group = { ...this.state[key] };
    group.data[index].selected = checked;
    this.setState({ [key]: group });
  };

  render() {
    const { data, data_item, filter_data_search, start_date, end_date, page, modal_update, modal_update_item, list_mode } = this.state;

    const fmt = (value) => (value ? toFixed(value) : "0.00");
    const num = (value) => (value ? Number(value) : "0");
    const isNewMode = list_mode === "new";
    const activeData = isNewMode ? data_item : data;
    const hasSelected = data?.data?.some((e) => e.selected);
    const hasSelectedItem = data_item?.data?.some((e) => e.selected);

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายการตัดหนี้" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3">
                  <b>รายการตัดหนี้</b>
                </h4>
              </div>

              {/* สลับโหมด */}
              <div className="d-flex align-items-center mb-3">
                <div className="btn-group">
                  <button type="button" className={`mr-2 btn btn-sm ${list_mode === "old" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => this.switchListMode("old")}>
                    ตัดทั้งยอด (เดิม)
                  </button>
                  <button type="button" className={`btn btn-sm ${isNewMode ? "btn-primary" : "btn-outline-primary"}`} onClick={() => this.switchListMode("new")}>
                    เลือกตัดเฉพาะรายการ (ใหม่)
                  </button>
                </div>
              </div>

              {/* ตัวกรอง + ปุ่มลบรายการที่เลือก */}
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <div className="d-flex align-items-center row mx-0">
                  <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1 mb-3" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ filter_data_search: e.target.value })} value={filter_data_search} />
                  <div className="wpx-200 mb-3">
                    <DatePicker className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ start_date: e })} value={start_date} />
                  </div>
                  <span className="mb-3">ถึง</span>
                  <div className="wpx-200 mb-3">
                    <DatePicker className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ end_date: e })} value={end_date} />
                  </div>
                  <button className="btn btn-primary px-3 mb-3 mx-1" onClick={this.Search}>
                    ค้นหา
                  </button>
                  <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={this.Reset}>
                    รีเซ็ท
                  </button>
                </div>

                {!isNewMode && hasSelected && (
                  <button className="btn btn-danger px-3 mb-3 mx-1" onClick={() => confirmDelete(() => this.cancelClearBill(data.data.filter((e) => e.selected).map((e) => e.record_water_id)))}>
                    ลบรายการที่เลือก
                  </button>
                )}

                {isNewMode && hasSelectedItem && (
                  <button className="btn btn-danger px-3 mb-3 mx-1" onClick={() => confirmDelete(() => this.cancelClearBillItem(data_item.data.filter((e) => e.selected).map((e) => e.writeoff_item_id)))}>
                    ลบรายการที่เลือก
                  </button>
                )}
              </div>

              <div className="table-responsive">
                {!isNewMode ? (
                  /* ---------- ตารางโหมดตัดทั้งยอด ---------- */
                  <table className="table table-borderless table-striped text-nowrap">
                    <thead className="bg-dark-blue text-white">
                      <tr className="bg-primary">
                        <th>
                          <input type="checkbox" className="pointer" onChange={this.toggleAll("data")} checked={data?.data?.length > 0 && data.data.every((item) => item.selected)} />
                        </th>
                        <th className="text-left">บ้านเลขที่</th>
                        <th className="text-left">ชื่อ-นามสกุล</th>
                        <th className="text-left">วันที่จดมาตร</th>
                        <th className="text-left">เลขมาตรเดือนนี้</th>
                        <th className="text-left">เลขมาตรเดือนก่อน</th>
                        <th className="text-left">จำนวนหน่วยที่ใช้</th>
                        <th className="text-left">ค่าน้ำประปา</th>
                        <th className="text-left">ค่ารักษาอุปกรณ์น้ำ</th>
                        <th className="text-left">ค่าส่วนกลาง</th>
                        <th className="text-left">ค่าขยะ</th>
                        <th className="text-left">ค่าเคเบิล</th>
                        <th className="text-left">รายรับอื่นๆ</th>
                        <th className="text-left">เพิ่ม/ลดหนี้</th>
                        <th className="text-left">ค่าเบี้ยประกัน</th>
                        <th className="text-left">ค่าต่อกลับมิเตอร์</th>
                        <th className="text-left">ค่าปรับชำระล่าช้า</th>
                        <th className="text-left">รวม(บาท)</th>
                        <th className="text-center">จัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!data?.data?.length ? (
                        <tr>
                          <td colSpan={19} className="text-center py-3">
                            ไม่มีข้อมูล
                          </td>
                        </tr>
                      ) : (
                        data.data.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <input type="checkbox" className="pointer" checked={item.selected || false} onChange={(e) => this.toggleRow("data")(index, e.target.checked)} />
                            </td>
                            <td>{item.address_number || "-"}</td>
                            <td>{item.full_name || "-"}</td>
                            <td>{item.datetime_create ? format_date(item.datetime_create) : "-"}</td>
                            <td>{num(item.current_gauge_number)}</td>
                            <td>{num(item.last_gauge_number)}</td>
                            <td>{num(item.unit_used)}</td>
                            <td>{fmt(item.water_bill)}</td>
                            <td>{fmt(item.equipment_maintenance_fee)}</td>
                            <td>{fmt(item.common_expenses)}</td>
                            <td>{fmt(item.waste_cost)}</td>
                            <td>{fmt(item.cable_cost)}</td>
                            <td>{fmt(item.other_income)}</td>
                            <td>{fmt((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                            <td>{fmt(item.fire_cost)}</td>
                            <td>{fmt(item.meter_connect_cost)}</td>
                            <td>{fmt(item.late_payment)}</td>
                            <td>{fmt(item.total_amount)}</td>
                            {/* ปุ่มลบรายตัวจะซ่อนเมื่อมีการติ๊กเลือกแถวไว้ (ให้ใช้ปุ่มลบรายการที่เลือกแทน) */}
                            <td className="text-center d-flex">
                              {!hasSelected ? <ActionIcon color="danger" icon={ICON.delete} title="ยกเลิกการตัดหนี้" className="mx-auto mb-0" onClick={() => this.setState({ id: item.record_water_id, modal_update: true })} /> : <div className="hpx-24"></div>}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                ) : (
                  /* ---------- ตารางโหมดเลือกตัดเฉพาะรายการ ---------- */
                  <table className="table table-borderless table-striped text-nowrap">
                    <thead className="bg-dark-blue text-white">
                      <tr className="bg-primary">
                        <th>
                          <input type="checkbox" className="pointer" onChange={this.toggleAll("data_item")} checked={data_item?.data?.length > 0 && data_item.data.every((item) => item.selected)} />
                        </th>
                        <th className="text-left">บ้านเลขที่</th>
                        <th className="text-left">ชื่อ-นามสกุล</th>
                        <th className="text-left">วันที่จดมาตร</th>
                        <th className="text-left">เลขมาตรเดือนนี้</th>
                        <th className="text-left">เลขมาตรเดือนก่อน</th>
                        <th className="text-left">จำนวนหน่วยที่ใช้</th>
                        {writeoffItemColumns.map((col) => (
                          <th className="text-left" key={col.key}>
                            {col.label}
                          </th>
                        ))}
                        <th className="text-left">รวม(บาท)</th>
                        <th className="text-center">จัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!data_item?.data?.length ? (
                        <tr>
                          <td colSpan={writeoffItemColumns.length + 8} className="text-center py-3">
                            ไม่มีข้อมูล
                          </td>
                        </tr>
                      ) : (
                        data_item.data.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <input type="checkbox" className="pointer" checked={item.selected || false} onChange={(e) => this.toggleRow("data_item")(index, e.target.checked)} />
                            </td>
                            <td>{item.address_number || "-"}</td>
                            <td>{item.full_name || "-"}</td>
                            <td>{item.meter_datetime_create ? format_date(item.meter_datetime_create) : "-"}</td>
                            <td>{num(item.current_gauge_number)}</td>
                            <td>{num(item.last_gauge_number)}</td>
                            <td>{num(item.unit_used)}</td>
                            {writeoffItemColumns.map((col) => (
                              <td key={col.key}>{fmt(col.compute ? col.compute(item) : item[col.key])}</td>
                            ))}
                            <td>{fmt(item.total_selected_amount)}</td>
                            <td className="text-center d-flex">
                              {!hasSelectedItem ? (
                                <ActionIcon color="danger" icon={ICON.delete} title="ยกเลิกการตัดหนี้" className="mx-auto mb-0" onClick={() => this.setState({ id_item: item.writeoff_item_id, modal_update_item: true })} />
                              ) : (
                                <div className="hpx-24"></div>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              <Paginate className="d-flex justify-content-between row mx-0 w-100 px-3 mt-3" data={activeData} page={page} onChange={(value) => this.setState({ page: value }, this.loader())} />
            </div>
          </div>
        </div>

        {/* popup ยืนยันยกเลิกตัดหนี้ — โหมดตัดทั้งยอด */}
        <Modal show={modal_update} onHide={() => this.setState({ modal_update: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ยืนยันการยกเลิกการตัดหนี้</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3">
              <label>ท่านแน่ใจว่าต้องการยกเลิกการตัดหนี้ หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label>
            </div>
            <div className="d-flex">
              <button className="btn btn-outline-primary w-50 mx-1" onClick={() => this.setState({ modal_update: false })}>
                ยกเลิก
              </button>
              <button className="btn btn-danger w-50 mx-1" onClick={() => this.cancelClearBill([this.state.id])}>
                ยืนยัน
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup ยืนยันยกเลิกตัดหนี้ — โหมดเลือกตัดเฉพาะรายการ */}
        <Modal show={modal_update_item} onHide={() => this.setState({ modal_update_item: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ยืนยันการยกเลิกการตัดหนี้</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3">
              <label>ท่านแน่ใจว่าต้องการยกเลิกการตัดหนี้ หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label>
            </div>
            <div className="d-flex">
              <button className="btn btn-outline-primary w-50 mx-1" onClick={() => this.setState({ modal_update_item: false })}>
                ยกเลิก
              </button>
              <button className="btn btn-danger w-50 mx-1" onClick={() => this.cancelClearBillItem([this.state.id_item])}>
                ยืนยัน
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
